export enum EFeaturesGroupID {
  /** Условия сделки **/
  BargainTerms = 'bargainTerms',
  /** О квартире **/
  AboutFlat = 'aboutFlat',
  /** О доме **/
  AboutBuilding = 'aboutBuilding',
  /** О загородном доме **/
  AboutSuburbanBuilding = 'aboutSuburbanBuilding',
  /** Об участке **/
  AboutLand = 'aboutLand',
  /** Коммерческая **/
  Commercial = 'commercial',
  /** Коммуникации **/
  Communications = 'communications',
  /** Юридическая информация **/
  Legal = 'legal',
}

export interface ITooltip {
  title: string;
  value: string;
}

export interface IFeature {
  label: string;
  tooltip?: ITooltip | null;
  value: string;
}

export interface IFeatures {
  id: EFeaturesGroupID;
  features: IFeature[];
  title: string;
}

export interface IFeaturesData {
  features: IFeatures[];
}
